import { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Locale } from "@dealer-center/ddc-core-utils";
import type { ControlcenterAPIInterfaceExternal } from "@dealer-center/ddc-pages-controlcenter-interface";
import type { decodedJwtAndPermissions } from "@dealer-center/ddc-api-user-interface";
import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import { useReadAPI } from "@dealer-center/ddc-pages-inventory-manager-fetch";
import LABELS from "./labels.json";

export const InventoryManager = () => {
  const [locale, setLocale] = useState("en-US");
  const { asAccount, asUser } = useParams<{
    asAccount: string;
    asUser: string;
  }>();
  const { ccUserInfo, userEntity } = useOutletContext<{
    ccUserInfo: ControlcenterAPIInterfaceExternal;
    userEntity: decodedJwtAndPermissions;
  }>();
  const navigate = useNavigate();
  const { "inventory-manager-page-access": shouldDisplayInventory } =
    useCC9Flags();

  useEffect(() => {
    if (shouldDisplayInventory === false) {
      navigate("/"); // Redirect to root
    }
  }, [shouldDisplayInventory, navigate]);

  Locale.setLabelsOnce(LABELS);

  useEffect(() => {
    const newLocale = Locale.getLocale();

    if (locale !== newLocale) {
      Locale.change(newLocale);
      setLocale(newLocale);
    }
  }, [locale]);

  const langParam = locale.replace("-", "_");
  const defaultSearchParams = new URLSearchParams({
    // added notes for future reference
    c: "{}", // condition filters like {"new": true, "used": true}
    isDeepLink: "false",
    k: "[]", // keywords search like ["ford", "f-150"]
    l: "25", // page size
    lang: langParam,
    o: "0", // page offset
    orderBy: JSON.stringify([{ field: "inventoryDate", direction: "desc" }]),
    q: "{}" // additional query filters like {"make": "ford", "model": "f-150", "year": 2020}
  }).toString();

  const vehicleSearchResult = useReadAPI({
    resource: "vehiclesearch",
    asAccount: asAccount || "",
    asUser: asUser || "",
    locale: langParam,
    extraURLParams: `&${defaultSearchParams}`
  });

  useEffect(() => {
    if (vehicleSearchResult.data) {
      console.log("vehicleSearch result:", vehicleSearchResult.data);
    }
  }, [vehicleSearchResult.data]);

  const displayName = asAccount || ccUserInfo?.userId || "User";

  return (
    <div className="inventory-manager-container">
      <h1>{`${Locale.getText("INVENTORY_HEADING")} ${displayName}`}</h1>
    </div>
  );
};
